import {
    ACTIVE_CONNECTING_LINES, INACTIVE_CONNECTING_LINES, ACTIVE_ENDPOINT, INACTIVE_ENDPOINT, LABEL_PROPERTIES, LABEL_DRAGPOINT, ERROR_CONNECTING_LINES, ERROR_ENDPOINT, DISABLED_CONNECTING_LINES, DISABLED_ENDPOINT
} from "../cell/grid-cell.config";
import {
    drawMiddleCircleConnectingLine, drawConnectingLineMultiplePoints, calculateMultiplePointSegmentMidpoint, drawConnectingLinePointer, createNestedCircle, notificationBellShape
} from "../components.utils";

import { GridConfig } from "../../modules/GridConfig";
import { ConnectingLineHandler } from "../../modules/ConnectingLineHandler";
import { DiagramUtils } from "../../../../diagram/diagram-assets/DiagramUtils";
import { getInstanceIDFromCanvasInstance } from "../../../../diagram/diagram-assets/diagram-positioning-state";

/**
 * @description Connecting line instance
 */
export class ConnectionLine {
    state = {
        selected: false, hover: false, active: false, apiActive: false, drawed: false, directSelection: false
    };

    layout = { path: null, endSide: null, styles: {} };

    ctx;

    triangleSideLength = 8;

    uuid;

    label;

    midPoint;

    midPointRadius;

    lineFill;

    styles;

    middleLineFillStyle;

    circlesFills;

    gridConfig;

    connectingLineHandler;

    labelHandler;

    labelProperties = LABEL_PROPERTIES;

    notificationBellWidth = 6;

    data;

    constructor(layout, state, canvas, data, labelHandler) {
        this.layout = { ...this.layout, ...layout };
        this.state = { ...this.state, ...state };
        this.ctx = canvas;
        this.data = data;
        if (data && data.uuid) this.uuid = data.uuid;
        else this.uuid = new DiagramUtils().generateUUID();
        this.gridConfig = new GridConfig(getInstanceIDFromCanvasInstance(this.ctx));
        this.connectingLineHandler = new ConnectingLineHandler(getInstanceIDFromCanvasInstance(this.ctx));
        this.labelHandler = labelHandler;
    }

    /**
     * @description draw the connecting line
     */
    draw() {
        this.setStylesAndPoints();
        drawConnectingLineMultiplePoints(this.layout.path, this.styles, this.ctx, true);
        drawMiddleCircleConnectingLine(this.midPoint, this.midPointRadius, this.middleLineFillStyle, this.ctx);
        const endPath = this.layout.path[this.layout.path.length - 1];
        drawConnectingLinePointer(endPath, this.lineFill, this.layout.endSide, this.triangleSideLength, this.ctx, this.gridConfig);
        this.drawLabel();
    }

    /**
     * @description draw the connecting line label
    */
    drawLabel() {
        const connectorObject = this.labelHandler.getConnectorLabel(this.uuid, this);
        const label = connectorObject && connectorObject.label && connectorObject.label.value ? connectorObject.label.value : null;
        if (label) {
            this.ctx.textBaseline = "top";
            this.ctx.textAlign = "center";
            this.ctx.font = `${this.labelProperties.fontLabel}px`;
            // this.ctx.fillStyle = this.state.directSelection ? "#256BDE" : "#444444";

            let widthOfPluginText = null; const scope = this; const fillStyleConn = "#444444";
            const textObject = this.labelHandler.getLabelWidth(this.ctx, label);
            const reduceHeight = parseInt(this.labelHandler.labelProperties.fontLabel) + this.labelProperties.paddingLabelY + 3;

            if (textObject.secondLine) {
                widthOfPluginText = textObject.labelWidth;
                this.labelHandler.createBackgroundLabelRectangle(connectorObject.label.x, connectorObject.label.y, widthOfPluginText.width, this.ctx, "LABELCONN", "HAS_SECOND_LINE");
                setTimeout(() => {
                    scope.ctx.fillStyle = fillStyleConn;
                    scope.ctx.fillText(textObject.firstLine, connectorObject.label.x,
                        connectorObject.label.y - parseInt(this.labelHandler.labelProperties.fontLabel) - parseInt(this.labelHandler.labelProperties.paddingLabelTopBottom) - (parseInt(this.labelHandler.labelProperties.paddingLabelTopBottom) / 2));
                    scope.ctx.fillText(textObject.secondLine, connectorObject.label.x, connectorObject.label.y - parseInt(this.labelHandler.labelProperties.paddingLabelTopBottom) / 2);
                }, 0);
            } else {
                widthOfPluginText = textObject.labelWidth;
                this.labelHandler.createBackgroundLabelRectangle(connectorObject.label.x, connectorObject.label.y, widthOfPluginText.width, this.ctx, "LABELCONN");
                setTimeout(() => {
                    scope.ctx.fillStyle = fillStyleConn;
                    scope.ctx.fillText(textObject.firstLine, connectorObject.label.x, connectorObject.label.y);
                }, 0);
            }

            if (this.data && this.data.notification) {
                notificationBellShape(this.midPoint.x - (widthOfPluginText.width / 2) - this.labelProperties.paddingLabelX - this.notificationBellWidth / 2,
                    this.midPoint.y - (textObject.secondLine ? reduceHeight : reduceHeight * 2 / 3), this.state.directSelection ? "#256BDE" : "#444444",
                    this.ctx);
            }

            createNestedCircle(connectorObject.label.x - (widthOfPluginText.width / 2) - this.labelHandler.labelProperties.paddingLabelX - this.labelHandler.labelProperties.dragPointLabelRadius
                - (this.data && this.data.notification ? this.notificationBellWidth : 0),
            connectorObject.label.y + (textObject.secondLine ? -(this.labelHandler.labelProperties.dragPointLabelRadius + this.labelHandler.labelProperties.fontLabel / 2) : parseInt(this.labelHandler.labelProperties.fontLabel) / 2),
            [this.labelProperties.dragPointLabelRadius], LABEL_DRAGPOINT, this.ctx, { fillStyle: this.labelHandler.labelProperties.dragPointFillConnector });
        }
    }

    /**
     * @description sets the connecting line styles and points
     */
    setStylesAndPoints(connectorFromState, connectorToState) {
        this.state.selected = this.getSelectedStatus();
        // for AppTracer
        if (connectorFromState && connectorToState && connectorToState.readonlyDisabled) {
            const checkIfPluginAscOrder = (connectorFromState.pluginIndex && connectorToState.pluginIndex && ((connectorFromState.pluginIndex + 1) < connectorToState.pluginIndex))
                                        || (!connectorFromState.pluginIndex && !connectorToState.pluginIndex && !(connectorFromState.insideParallelIndex && connectorToState.insideParallelIndex));
            this.styles = (connectorToState.disabled || connectorFromState.disabled || checkIfPluginAscOrder) ? DISABLED_CONNECTING_LINES : ACTIVE_CONNECTING_LINES;
            this.circlesFills = (connectorToState.disabled || connectorFromState.disabled || checkIfPluginAscOrder) ? DISABLED_ENDPOINT : ACTIVE_ENDPOINT;
            this.labelHandler.updateStateConnectorLabel(connectorFromState.disabled ? connectorFromState : connectorToState, checkIfPluginAscOrder, this.uuid);
        } else if (!this.state.selected && this.state.connectorErrorState) {
            this.styles = ERROR_CONNECTING_LINES;
            this.circlesFills = ERROR_ENDPOINT;
        } else {
            this.styles = ((this.state.readonlyDisabled && !this.state.disabled) || ((this.state.selected || this.state.directSelection) && !this.state.disabled)) ? ACTIVE_CONNECTING_LINES : INACTIVE_CONNECTING_LINES;
            this.circlesFills = ((this.state.readonlyDisabled && !this.state.disabled) || ((this.state.selected || this.state.directSelection) && !this.state.disabled)) ? ACTIVE_ENDPOINT : INACTIVE_ENDPOINT;
        }
        this.midPoint = calculateMultiplePointSegmentMidpoint(this.layout.path);
        this.midPointRadius = 3;
        this.lineFill = this.circlesFills.fillStyleFirst;
        this.middleLineFillStyle = this.circlesFills.fillStyleFirst;
    }

    /**
     * @description returns the connecting lines selected status
     */
    getSelectedStatus() {
        const thisConnectorData = this.connectingLineHandler.connectors.get(this.uuid);
        const fromCell = this.connectingLineHandler.cells.get(thisConnectorData.from);
        const toCell = this.connectingLineHandler.cells.get(thisConnectorData.to);
        return this.state.selected || this.state.active || this.state.apiActive || fromCell.ref.state.selected || toCell.ref.state.selected;
    }

    /**
     * @description performs a partial update on the provided sections
     * @param {*} sections
     */
    partialUpdate(sections, connectorFromState, connectorToState) {
        this.setStylesAndPoints(connectorFromState, connectorToState);
        for (let i = 0; i < sections.length; i++) {
            const prev = i !== 0 ? sections[i - 1] : null;
            drawConnectingLineMultiplePoints(sections[i], this.styles, this.ctx, prev);
            // this.drawLabel();
        }
        drawMiddleCircleConnectingLine(this.midPoint, this.midPointRadius, this.middleLineFillStyle, this.ctx);
        const endPath = this.layout.path[this.layout.path.length - 1];
        drawConnectingLinePointer(endPath, this.lineFill, this.layout.endSide, this.triangleSideLength, this.ctx, this.gridConfig);
    }

    /**
     * @description - Updates the conneecting line instance with the provided values
     * @param {Object} layout
     * @param {Object} state
     */
    update(layout, state) {
        if (layout) this.layout = { ...this.layout, ...layout };
        if (state) this.state = { ...this.state, ...state };
        if (this.state.apiActive && !this.state.active) {
            this.state.active = this.state.apiActive;
        }
    }
}
